angular.module('charts')
  .directive("assignFocusButton", function() {
      return {
          restrict: "E",
          scope: {
              busy: '=',
              label: '@'
          },
          transclude: true,
          templateUrl: '/resources/charts/partials/assign-focus-button.html',
          controller: ['$scope', '$state', 'assignMode', 'authentication', 'dblAnalyticsProvider', function($scope, $state, $assignMode, dblAuthentication, $analytics) {

              var updateAssignmentsAllowed = function() {
                  var isClassroomLevel = $state.current.name === 'classroom' || $state.current.name === 'student';

                  if ($state.current.name === 'guardian') {
                      var customer = dblAuthentication.getCustomer();

                      // studentDistrictId is equal to -1 for students that aren't in classrooms, which means it's a guardian
                      // only level classroom
                      isClassroomLevel = $state.params.studentDistrictId === '-1' ||  customer.hasTag('ASSIGN_FOCUS_ENABLED');
                  }

                  var isAssignMode = $assignMode.isAssignMode;
                  var isTagged = $assignMode.assignmentsAllowed();

                  // var currentStandardAllowed = $assignMode.currentStandardAllowed();

                  // RM52613 ... remove the ast blocking. Leaving the code in place for any future reference.
                  $scope.assignmentsAllowed = isTagged && isClassroomLevel && !isAssignMode; // && currentStandardAllowed
              };

              updateAssignmentsAllowed();

              $scope.onAssignLessonClick = function () {
                  $analytics.eventTrack('Add Assignment Clicked', {
                      category: 'Assign Focus',
                      label: $state.current.name
                  });
                  $assignMode.onClickAssignMode();
              };

              $scope.$on('updateStudentDataForGuardian', function (e) {
                  updateAssignmentsAllowed();
              });
          }]
      };
  });
